import React from 'react';
import '../App.css';

const AuthorPermissionModal = ({ isOpen, onClose, user }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="author-permission-modal" onClick={e => e.stopPropagation()}>
        <div className="author-permission-header">
          <h3>需要作者权限</h3>
          <button className="modal-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        <div className="author-permission-body">
          <div className="permission-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M19.5 10.5C19.5 17 12 22 12 22C12 22 4.5 17 4.5 10.5C4.5 6.35786 7.85786 3 12 3C16.1421 3 19.5 6.35786 19.5 10.5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>

          <div className="permission-content">
            <h4>您的账户尚未开通作者权限</h4>
            <p>要创建和发布文章，您需要先开通作者身份。</p>

            <div className="permission-info">
              <h5>如何开通作者权限：</h5>
              <ul>
                <li>联系系统管理员请求开通作者身份</li>
                <li>提供您的用户名：<strong>{user?.username || '未知用户'}</strong></li>
                <li>管理员会将您的账户与对应的作者信息关联</li>
              </ul>
            </div>

            <div className="permission-note">
              <p><strong>提示：</strong>开通作者权限后，请重新登录以刷新权限信息。</p>
            </div>
          </div>
        </div>

        <div className="author-permission-footer">
          <button className="btn-primary" onClick={onClose}>
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthorPermissionModal;